import React from "react";
import { Example } from "./Example";

import styles from "./Example.module.css";

export const DefaultQuestions: string[] = [
    "List the 5 most expensive Compactors type Landfill Compactors-Self Propelled category machines weighing from 40000 to 60000 pounds to rent and employ for 1000 hours per year under moderate field conditions.",
    "Compare the cost to rent a Case TV370 2023 to a Caterpillar 289D3 2023 if employed 1000 hours per year under severe field conditions.",
    "Plot the max, mean, and min operating cost per year for a Caterpillar 815f 2005 under moderate operating conditions and maintained according to OEM recommendations.",
    "Forecast the list price of a Caterpillar 815F.",
    "Forecast the auction price for a Caterpillar 815F 2009 for the next 3 years and plot the results."
];

interface Props {
    questions: string[];
    onExampleClicked: (value: string) => void;
}

export const ExampleList: React.FC<Props> = ({ questions, onExampleClicked }) => {
    return (
        <ul className={styles.examplesNavList}>
            {questions.map((x, i) => (
                <li key={i}>
                    <Example text={x} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
